import { Box, Text } from "@chakra-ui/react";

const CampDashboard = () => {
  return (
    <Box>
      <Text fontWeight="semibold" textStyle="4xl">
        Dashboard
      </Text>
      <Text pb="5">Bienvenido al portal de campamento.</Text>
    </Box>
  );
};

export default CampDashboard;
